import { render, staticRenderFns } from "./escalationCallDetails.vue?vue&type=template&id=2600540f&scoped=true"
import script from "./escalationCallDetails.vue?vue&type=script&lang=js"
export * from "./escalationCallDetails.vue?vue&type=script&lang=js"
import style0 from "./escalationCallDetails.vue?vue&type=style&index=0&id=2600540f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600540f",
  null
  
)

export default component.exports